import EntityManageView from 'Components/EntityManageView';
import { actions } from 'ducks/readings';
import { sortBy } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';
import formSelectors from 'selectors/form';
import { metadataFields } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getReadingMetadata } from 'utils/getMetadata.js';

const Component = props => {
    const equipmentId = useSelector(state => state.drawerView.entityId);
    const formValues = useSelector(state => formSelectors.getFormValues(state));
    const readingKinds = useSelector(state => state.bootstrap.reading_kinds);
    const submitting = useSelector(state => state.readings.submitting);

    const equipment = useSelector(state => state.equipments.models[equipmentId]);
    const metadata = getReadingMetadata(equipment);

    const stateProps = { formValues, metadata, readingKinds, equipmentId, submitting };

    const actionProps = ({
        change: change,
        create: actions.useCreate(),
        update: actions.useUpdate()
    });

    const isMetal = equipment.out_protocol_slug === 'reading_metal';
    const readingKindName = readingKinds.find(readingKind => readingKind.id === formValues.reading_kind_id)?.name;
    // Digital and actuator readings are always OnOff: the API rejects any other reading kind.
    const onOffReadingKind = readingKinds.find(readingKind => readingKind.name === 'OnOff');

    const dispatch = useDispatch();
    useEffect(() => {
        if (isMetal) {
            // Metal readings take the kind name as their name; digital ports keep the
            // technician's naming (DI1, DO2, ...).
            if (readingKindName) {
                dispatch(change('form', 'name', readingKindName));
            }
        } else {
            dispatch(change('form', 'reading_kind_id', onOffReadingKind.id));
        }
    }, [dispatch, isMetal, onOffReadingKind.id, readingKindName]);

    const formSchema = [];

    if (isMetal) {
        formSchema.push(
            {
                type: 'select',
                label: 'Reading Kind\x2a',
                name: 'reading_kind_id',
                validate: [validators.required],
                formData: sortBy(readingKinds, 'name')
            },
            {
                type: 'text',
                label: 'Name\x2a (avoid changing unless absolutely necessary)',
                name: 'name',
                validate: [validators.required]
            }
        );
    } else {
        formSchema.push(
            {
                disabled: true,
                type: 'select',
                label: 'Reading Kind (digital readings are always OnOff)',
                name: 'reading_kind_id',
                formData: [onOffReadingKind]
            },
            {
                type: 'text',
                label: 'Name\x2a (please use standardized names, eg: DI/DO/Port)',
                name: 'name',
                validate: [validators.required]
            }
        );
    }

    formSchema.push(...metadataFields(metadata));

    formSchema.push(
        {
            type: 'checkBox',
            label: 'Activate Measurement?',
            name: 'activate_measurement'
        },
        {
            type: 'checkBox',
            label: 'Create Indicator?',
            name: 'create_indicator'
        }
    );

    return (
        <EntityManageView
            extraData={{ equipment_id: equipmentId }}
            formSchema={formSchema}
            label="New Reading"
            {...stateProps}
            {...actionProps}
            {...props}
        />
    );
};

export default Component;
